import classNames from 'classnames';
import { map } from 'lodash';
import { preventJavascriptUrls } from '../../../../services/security';
import { modulo } from '../../../services/Math';
import { trackEvent } from '../../../services/Tracking';
import resultStyles from '../ResultList/style.m.less';
import styles from './style.m.less';

export default function PageList({ pages, selectedItem, offset, totalNumberOfItems, doHideResults }) {
    return (
        <ul className={styles.pageList}>
            {map(pages, (page, index) => (
                <PageItem
                    key={page.value.url}
                    page={page}
                    itemIsSelected={isSelected(selectedItem, offset, totalNumberOfItems, index)}
                    doHideResults={() => {
                        trackEvent({
                            category: 'navigation header search bar',
                            action: 'go to page',
                            label: page.value.name,
                        });
                        return doHideResults();
                    }}
                />
            ))}
        </ul>
    );
}

function isSelected(selectedItem, offset, totalNumberOfItems, index) {
    if (selectedItem === null) {
        return false;
    }

    return index + offset === modulo(selectedItem, totalNumberOfItems);
}

function PageItem({ page, doHideResults, itemIsSelected }) {
    const itemClasses = classNames(resultStyles.item, resultStyles.itemSmall, resultStyles.itemWithHover, {
        [resultStyles.itemSelected]: itemIsSelected,
    });

    return (
        <li className={itemClasses}>
            <a
                tabIndex="-1"
                href={preventJavascriptUrls(page.value.url)}
                className={resultStyles.linkPage}
                onClick={doHideResults}
            >
                {page.value.icon}
                &nbsp;{page.value.name}
            </a>
        </li>
    );
}
